/** Toast is portaled to document.body; Radix treats clicks on it as "outside" the modal. */
const TOAST_ROOT_SELECTOR = ".Toastify__toast-container";

function nodeToNearestElement(node) {
  if (!node) return null;
  if (node.nodeType === Node.ELEMENT_NODE) return node;
  if (node.nodeType === Node.TEXT_NODE) return node.parentElement;
  return null;
}

/**
 * @param {Event} event Radix outside event (CustomEvent with detail.originalEvent) or native
 */
export function getOutsidePointerTarget(event) {
  const original = event?.detail?.originalEvent;
  if (original?.target != null) return nodeToNearestElement(original.target);
  return nodeToNearestElement(event?.target);
}

export function isReactToastifyTarget(target) {
  const el = nodeToNearestElement(target);
  return el instanceof Element && Boolean(el.closest(TOAST_ROOT_SELECTOR));
}

export function isReactToastifyOutsideEvent(event) {
  return isReactToastifyTarget(getOutsidePointerTarget(event));
}
